import Vue from 'vue';
import {
  getReport,
  getFollow,
  getReadNum,
  getFollowIndustry,
  getFollowOrg,
  getFollowAuthor,
} from '@/apis/index';
import { REGEX_FUTURES_CODE, FUTURES_MARKET } from '@/config/config';

type env = 'dev' | 'test' | 'release';
/**
 * 获取当前环境状态 dev开发环境  test测试环境  release正式环境
 * @returns 返回当前
 */
export function getCurrentEnvMode() {
  // 获取当前环境属性 设置可能的值规范
  return process.env.VUE_APP_CURRENTMODE as env;
}

//拼接获取阅读量的参数
export function getReadCount(self: any, LIST: Array<object>) {
  self.str = '';
  for (let i: number = 0; i < LIST.length; i++) {
    const k = LIST[i] as any;
    if (i !== LIST.length - 1) {
      self.str = `${self.str}seq_${k.pid},`;
    } else {
      self.str = `${self.str}seq_${k?.pid}`;
    }
  }
  //获取阅读量
  getReadNum({
    field: 'clicks',
    key: self.str,
  }).then(res1 => {
    const that = self;
    const response = res1 as any;
    const obj = response.result;
    if (obj) {
      Object.getOwnPropertyNames(obj).forEach(function (key) {
        for (let k: number = 0; k < that.reportList.length; k++) {
          if (key.substr(4) == that.reportList[k].pid) {
            that.$set(that.reportList[k], 'readNum', obj[key]);
          }
        }
      });
    }
  });
}

/**
 * 获取研报
 * @param {Object} obj 请求参数
 */
export function getReportAll(obj: any) {
  return getReport(obj);
}

export function takePat(that: any, index: number) {
  const avatar = document.getElementsByClassName('card-header-avatar')[index] as HTMLElement;
  setTimeout(() => {
    if (avatar.getAttribute('shaking')) {
      avatar.removeAttribute('shaking');
    } else {
      that.temp = 1;
    }
  }, 50);
  setTimeout(() => {
    if (avatar.getAttribute('shaking')) {
      avatar.removeAttribute('shaking');
    } else {
      that.temp = 1;
    }
    avatar.setAttribute('shaking', 'true');
  }, 100);
}

/**
 * @description: 动态加载 js 脚本文件
 * @param {String} url 脚本文件地址
 * @param {Function} nextFn 脚本加载完成之后的回调
 */
export function loadJs(url: string, nextFn: () => void) {
  // 配置属性
  const body = document.getElementsByTagName('body')[0];
  const jsNode = document.createElement('script');
  jsNode.setAttribute('type', 'text/javascript');
  jsNode.setAttribute('src', url);
  // 加载onload事件处理回调
  jsNode.onload = function () {
    // 加载js成功后触发回调
    nextFn && nextFn();
  };
  // 插入dom
  body.appendChild(jsNode);
}

// 字符串下划线转驼峰
const formatToHump = (value: string) => value.replace(/\_(\w)/g, (_, letter) => letter.toUpperCase());

/**
 * 数据对象key 驼峰下划线互相转化
 * @param {Object} formatedata 需要转换的对象
 */
export function formatHumpLineTransfer(formatedata: any) {
  let hump = '';
  // 转换对象中的每一个键值为驼峰的递归
  const formatTransferKey = (data: any) => {
    if (data instanceof Array) {
      data.forEach(item => formatTransferKey(item));
    } else if (data instanceof Object) {
      for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
          hump = formatToHump(key);
          data[hump] = data[key];
          key !== hump && delete data[key];
          data[hump] instanceof Object && formatTransferKey(data[hump]);
        }
      }
    } else if (typeof data === 'string') {
      return formatToHump(data);
    } else {
      return data;
    }
    return data;
  };
  return formatTransferKey(formatedata);
}

/**
 * 调用客户端协议为同步逻辑，若需要在项目请求的拦截器中统一替换，需对方法进行异步封装
 * @param configUrl 需要替换的地址
 */
export function getUrlByPromise(configUrl: string): Promise<string> {
  return new Promise<string>(resolve => {
    try {
      window.dynamicDomain.exchangeHost(configUrl, function (url: string) {
        url ? resolve(url) : resolve(configUrl);
      });
    } catch (error) {
      resolve(configUrl);
    }
  });
}

/**
 * @description 跳转页面方式
 * @param url 跳转页面的地址
 * @param type 跳转页面的方式 normal 普通跳转 2804 客户端新开webview跳转
 * @param tabId 定义跳转后默认选中的tab 只有在客户端内才会生效
 */
export async function jumpBy2804(url: string, type: string = '2804', tabId: string = '') {
  const domainUrl = await getUrlByPromise(url);
  if (type === '2804') {
    if (window.getAppVersion()) {
      if (tabId) {
        window.location.href = `client.html?action=ymtz^url=${domainUrl}^webid=2205^fontzoom=no^mode=new^tabid=${tabId}`;
      } else {
        window.location.href = `client.html?action=ymtz^url=${domainUrl}^webid=2804^fontzoom=no^mode=new`;
      }
    } else {
      window.location.href = domainUrl;
    }
  } else if (type === '2017') {
    window.location.href = 'client.html?action=ymtz^webid=2017';
  } else {
    window.location.href = domainUrl;
  }
}

/**
 * @description 获取自选股列表
 * @param callback 回调函数
 */
export function getSelfStocks(callback: any) {
  window.callNativeHandler(
    'selfCodeAction',
    {
      action: 'getAllStocks',
    },
    function (data: any) {
      data && data.selfCodeList && typeof callback == 'function' && callback(data.selfCodeList);
    }
  );
}

/**
 * @description 添加自选股
 * @param marketId 自选股市场id
 * @param stockCode 自选股代码
 * @param callback 回调函数
 */
export function addSelfStocks(marketId: string, stockCode: string, callback: any) {
  window.callNativeHandler(
    'selfCodeAction',
    {
      action: 'addStocks',
      selfCodeListAdd: [
        {
          marketid: marketId,
          stockcode: `${stockCode}`,
        },
      ],
    },
    function (data: any) {
      data && typeof callback == 'function' && callback(data);
    }
  );
}

/**
 * @description 删除自选股
 * @param marketId 自选股市场id
 * @param stockCode 自选股代码
 * @param callback 回调函数
 */
export function delSelfStocks(marketId: string, stockCode: string, callback: any) {
  window.callNativeHandler(
    'selfCodeAction',
    {
      action: 'delStocks',
      selfCodeListDel: [
        {
          marketid: marketId,
          stockcode: `${stockCode}`,
        },
      ],
    },
    function (data: any) {
      data && typeof callback == 'function' && callback(data);
    }
  );
}

/**
 * 节流函数
 * @param fn 需要执行的函数
 * @param time 间隔时间
 * @returns 节流处理后的函数
 */
export function throttle(fn: () => void, time = 300) {
  let canRun: boolean = true;
  return function () {
    if (!canRun) return;
    canRun = false;
    setTimeout(() => {
      fn();
      canRun = true;
    }, time);
  };
}

/**
 * 截取名字首字做头像
 * @param name 名字
 * @returns 名字首字
 */
export function formatName(name: string) {
  const first = name?.slice(0, 1);
  return first;
}

/**
 * 格式化阅读量
 * @param num 阅读量
 * @returns 格式化后阅读量
 */
export function formatRead(num: number) {
  if (num < 10000 && num >= 0) {
    return num;
  } else if (num < 100000000 && num >= 10000) {
    const divide = (Number(num) / 10000).toFixed(1);
    return `${divide}万`;
  } else if (num >= 100000000) {
    const divide = (Number(num) / 100000000).toFixed(1);
    return `${divide}亿`;
  } else {
    return 0;
  }
}

/**
 * 格式化时间
 * @param date 时间
 * @returns 格式化后的年月日
 */
export function formatDate(date: string) {
  if (typeof date === 'number') {
    const n = new Date(date);
    const time = `${n.toLocaleDateString().replace(/\//g, '-')} ${n.toTimeString().substr(0, 8)}`;
    const arr = time.split(' ');
    return arr[0];
  } else {
    const arr = date.split(' ');
    return arr[0];
  }
}

/**
 * 节流函数
 * @param fn 需要执行的函数
 * @param time 间隔时间
 * @returns 节流处理后的函数
 */
export function autoColor(num: string): string {
  const value = `${num}`;
  let color = '';
  if (value === '--.--%' || value.match(/^\+?\d+(\.\d+)\%$/)) {
    color = '#FF2436';
  } else if (value.match(/^\-?\d+(\.\d+)\%$/)) {
    color = '#07AB4B';
  } else {
    color = `rgba(${window.getCssStyle() === 'black' ? '255, 255, 255' : '0, 0, 0'}, 0.84)`;
  }
  return color;
}

export function formatTime(time: Date, fmt = 'yyyy-MM-dd hh:mm:ss') {
  type formatTimeType = {
    // 月份
    'M+': number;
    // 日期
    'd+': number;
    // 小时
    'h+': number;
    // 分钟
    'm+': number;
    // 秒
    's+': number;
    // 季度
    'q+': number;
    // 毫秒
    S: number;
  };
  // 定义每个季度3个月
  const quarterlyMonths = 3;
  // 时间数据对象
  const o = {
    // 月份
    'M+': time.getMonth() + 1,
    // 日期
    'd+': time.getDate(),
    // 小时
    'h+': time.getHours(),
    // 分钟
    'm+': time.getMinutes(),
    // 秒
    's+': time.getSeconds(),
    // 季度
    'q+': Math.floor((time.getMonth() + quarterlyMonths) / quarterlyMonths),
    // 毫秒
    S: time.getMilliseconds(),
  };
  let formated = fmt;
  if (/(y+)/.test(formated)) {
    formated = formated.replace(
      RegExp.$1,
      `${time.getUTCFullYear()}`.substr(quarterlyMonths + 1 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(formated)) {
      const ele = `${o[k as keyof formatTimeType]}`;
      formated = formated.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? ele : `00${ele}`.substr(`${ele}`.length)
      );
    }
  }
  return formated;
}

/**
 * IOS手机消除滚动回弹
 * flag 是否关闭 0：关闭，非0：开启
 */
export function webviewBounce(flag: number = 0) {
  if (window.getPlatform() === 'iphone') {
    // 调用客户端协议取消回弹
    window.callNativeHandler('notifyWebHandleEvent', {
      method: 'WebviewBounce',
      params: { bounce: flag },
    });
  }
}

/**
 * web跳转分时
 * @param params stockCode 股票代码 market市场id
 * @param tabId 跳转的分时tab代码 默认设置新闻tab
 */
export function jumpTimeShare(params, tabId: string = '3') {
  const { stockCode, market } = params;
  if (window.getAppVersion()) {
    let code = stockCode;
    let marketId = market;
    if (`${market}` === '177' && code.length === 5 && code[0] === '0') {
      // 港股代码处理
      code = code.replace('0', 'HK');
    }
    if (!marketId && REGEX_FUTURES_CODE.test(code)) {
      marketId = FUTURES_MARKET;
    }
    const marketParam = marketId ? `^marketid=${marketId}` : '';
    // 端内执行跳转到对应股票代码的分时
    window.location.href = `client.html?action=ymtz^webid=2205^stockcode=${code}${marketParam}^tabid=${tabId}`;
  } else {
    console.log('客户端打开');
  }
}
//检查是否有关注，在分页加载后显示为已关注而不是什么都不显示
export function scanFollow(that: any, id: any) {
  if (id) {
    if (that.followArr.indexOf(id) !== -1) {
      that.followArr.splice(that.followArr.indexOf(id), 1);
    } else {
      that.followArr.push(id);
    }
  }
}

export function getFollowed(that: any, id: any, k: any) {
  if (id === k.authorId || id === k.orgId || id === k.organizationId) {
    that.$set(k, 'isSub', true);
  } else {
    that.$set(k, 'isSub', false);
  }
}

export function dealDeeply(that: any, res: any, k: any) {
  if (res.data.followList.indexOf(k.authorId ? k.authorId : k.orgId || k.organizationId) !== -1) {
    for (let j: number = 0; j < that.followArr.length; j++) {
      const judge =
        that.followArr[j] === k.authorId ||
        that.followArr[j] === k.orgId ||
        that.followArr[j] === k.organizationId;
      if (res.data.followList.indexOf(that.followArr[j]) !== -1 && judge) {
        that.$set(k, 'isSub', true);
        that.$set(k, 'needSub', false);
      }
    }
  } else {
    that.$set(k, 'isSub', false);
    that.$set(k, 'needSub', true);
  }
}
export function dealLastFollow(that: any, res: any, LIST: any) {
  for (let i: number = 0; i < LIST?.length; i++) {
    const k = LIST[i] as any;
    dealDeeply(that, res, k);
  }
}

export function getIsFollow(that: any, LIST: any, id: any) {
  scanFollow(that, id);
  that.follorStr = [];
  for (let i: number = 0; i < LIST?.length; i++) {
    const k = LIST[i] as any;
    that.follorStr.push(k.authorId ? k.authorId : k.orgId || k.organizationId);
  }
  getFollow({
    id_list: that.follorStr,
  }).then(response => {
    const res = response as any;
    for (let i: number = 0; i < LIST?.length; i++) {
      const k = LIST[i] as any;
      if (res.data.followList.indexOf(k.authorId ? k.authorId : k.orgId || k.organizationId) !== -1) {
        getFollowed(that, id, k);
        that.$set(k, 'needSub', false);
      } else {
        that.$set(k, 'isSub', false);
        that.$set(k, 'needSub', true);
      }
    }
    dealLastFollow(that, res, LIST);
  });
}

/**
 * 处理港股股票代码
 * @param item 研报item
 */
export function formatChg(item: any) {
  const code = item.code || item.stockCode;
  if (code) {
    if (code.length === 5 && code[0] === '0') {
      const HKCode = code.replace('0', 'HK');
      return Vue.prototype.$hqData[HKCode].chg;
    } else {
      return Vue.prototype.$hqData[code].chg;
    }
  } else {
    return false;
  }
}

/**
 * 处理多支港股股票代码
 * @param i 股票代码
 */
export function formatManyChg(i: any) {
  // :num="$hqData[i] && $hqData[i].chg"
  if (i.length === 5 && i[0] === '0') {
    const HKCode = i.replace('0', 'HK');
    return Vue.prototype.$hqData[HKCode].chg;
  } else {
    return Vue.prototype.$hqData[i].chg;
  }
}

/**
 * 评级转化
 * @param rating 评级数字
 */
export function formatRating(rating: number) {
  switch (rating) {
    case 0:
      return '不评级';
    case 1:
      return '买入';
    case 2:
      return '增持';
    case 3:
      return '中性';
    case 4:
      return '减持';
    case 5:
      return '卖出';
    default:
      return false;
  }
}

/**
 * 跳转查看研报
 * @param id 研报id
 */
export function jumpReport(id: string, isSelfMedia = false) {
  const url = isSelfMedia ? `https://news.10jqka.com.cn/m${id}/` : `https://news.10jqka.com.cn/m${id}_sr/`;
  jumpBy2804(url);
}

export function getClientHeight(): number {
  let clientHeight = 0;
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight =
      document.body.clientHeight < document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight;
  } else {
    clientHeight =
      document.body.clientHeight > document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight;
  }
  return clientHeight;
}

export function debounce(func: Function, time: number, immediate = false) {
  let timer: number | null = null;
  return (...args: any) => {
    if (timer) clearInterval(timer);
    if (immediate) {
      if (!timer) func.apply(this, args);
      timer = window.setTimeout(() => {
        timer = null;
      }, time);
    } else {
      timer = window.setTimeout(() => {
        func.apply(this, args);
      }, time);
    }
  };
}

/**
 * @description: 端内登录
 * @param {Function} nextFn 已登录执行的函数
 * @param {Function} ingFn 未登录并登录执行的函数
 */
export function appLogin(nextFn, ingFn) {
  if (window.getAccount()) {
    nextFn();
  } else {
    if (!window.loginInterval) {
      const RELOAD_TIME = 200;
      window.loginInterval = setInterval(() => {
        // 登陆完成
        if (window.getAccount()) {
          // 登录成功之后清除掉
          clearInterval(window.loginInterval);
          window.loginInterval = null;
          // 更新数据
          ingFn && ingFn();
        }
      }, RELOAD_TIME);
    }
    // 跳转客户端的登录界面
    window.location.href = 'http://eqhexin/changeUser';
  }
}

/**
 * 处理关注联动问题
 * @param LIST 研报列表
 */

export function listSearch(that: any, LIST: any) {
  LIST.forEach(item => {
    if (item.authorId) {
      that.$set(
        that.$followAuthorList,
        item.authorId,
        that.$followAuthorList.hasOwnProperty(item.authorId) ? that.$followAuthorList[item.authorId] : 1
      );
    } else {
      that.$set(
        that.$followOrgList,
        item.organizationId,
        that.$followOrgList.hasOwnProperty(item.organizationId || item.orgId)
          ? that.$followOrgList[item.organizationId || item.orgId]
          : 1
      );
    }
  });
}

/**
 * @description: 微信授权登录
 * @param {Function} nextFn 登录之后执行的函数
 * @param {string} redir 端外登录重定向的页面
 */
export function webLogin(nextFn, redir = location.href) {
  if (window.getAccount()) {
    nextFn();
  } else {
    // thsbx登录还是upass登录
    const redirHost = redir.split('?')[0];
    const isThsbx = redirHost.includes('thsbx.cn/');
    location.href = `https://upass.${
      isThsbx ? 'thsbx' : '10jqka.com'
    }.cn/login?platform=phone&source=upspace&view=public&redir=${encodeURIComponent(redir)}`;
  }
}

/**
 * @description: 验证登录（包含微信授权登录）
 * @param {Function} edFn 已经登录执行的函数
 * @param {Function} ingFn 未登录并且登录之后执行的函数
 * @param {string} redir 端外登录重定向的页面
 */
export function checkLogin(edFn, ingFn, redir = location.href) {
  window.getAppVersion() ? appLogin(edFn, ingFn) : webLogin(edFn, redir);
}

/**
 * 将一个对象组装成query查询的字符串
 * @param data 需要组装的对象
 */
export const queryParamsJoin = (data: { [propsName: string]: any }): string => {
  const result: string[] = [];
  Object.keys(data).forEach(key => {
    if (data[key]) {
      result.push(`${key}=${data[key]}`);
    }
  });
  return `${result.join('&')}`;
};

/**
 * @description: push类型封装
 * @param {string} path push拼接路径
 * @param {any} query query参数
 * @param {boolean} ishash query参数
 */
export function pushBy2804(path: string, query: any, ishash: boolean = true) {
  const { hostname, pathname } = location;
  const hash = ishash ? '#' : '';
  const queryStr = query ? `?${queryParamsJoin(query)}` : '';
  const url = `https://${hostname}${pathname}${hash}${path}${queryStr}`;
  jumpBy2804(url);
}
/**
 * 修改评级样式
 * @param deepReport 是否深度
 * @param item 研报信息
 */
export function changeRatingStyle(deepReport: any, item: any) {
  if (deepReport || (item.cat && item.cat.indexOf('深度') !== -1)) {
    switch (item.buyRating) {
      case 1:
        return {
          color: '#FF2436',
        };
      case 2:
        return {
          color: '#FF661A',
        };
      case 3:
        return {
          color: '#FF9500',
        };
      case 4:
        return {
          color: '#39BC6F',
        };
      case 5:
        return {
          color: '#07AB4B',
        };
      default:
        return {};
    }
  } else {
    switch (item.buyRating) {
      case 1:
        return {
          color: '#FF2436',
        };
      case 2:
        return {
          color: '#FF661A',
        };
      case 3:
        return {
          color: '#FF9500',
        };
      case 4:
        return {
          color: '#39BC6F',
        };
      case 5:
        return {
          color: '#07AB4B',
        };
      default:
        return false;
    }
  }
}

/**
 * 获取行情
 * @param res 接口返回数据
 */

export function dealHangqing(stockArr: any) {
  for (let j: number = 0; j < stockArr.length; j++) {
    if (stockArr[j].length === 5 && stockArr[j][0] === '0') {
      const code = stockArr[j].replace('0', 'HK');
      Vue.prototype.$hqData.addStockSub(code, null);
    } else {
      Vue.prototype.$hqData.addStockSub(stockArr[j], null);
    }
  }
}

export function getHangqing(res: any) {
  if (!res?.data?.list) return;

  const processStock = (stock: any) => {
    if (!stock?.stockCode || stock.stockCode.includes('!')) return;

    let code = stock.stockCode;
    let market = stock.marketId || stock.market;

    // 处理港股代码
    if (code.length === 5 && code[0] === '0') {
      code = code.replace('0', 'HK');
    }
    // 处理期货代码
    if (!market && REGEX_FUTURES_CODE.test(code)) {
      market = FUTURES_MARKET;
    }

    Vue.prototype.$hqData.addStockSub(code, market);
  };

  res.data.list.forEach(processStock);
}

/**
 * 跳转分时
 * @param item 研报数据
 */
export function jumpToFenshi(item: any) {
  if (item.stockCode) {
    const params = {
      stockCode: item.stockCode,
    };
    jumpTimeShare(params);
  } else {
    const params = {
      stockCode: item.code,
    };
    jumpTimeShare(params);
  }
}
//多个股票跳转分时
export function jumpFenshi(item: any, j: number) {
  if (item.stockCode) {
    const params = {
      stockCode: item.stockCode.split('!')[j],
    };
    jumpTimeShare(params);
  } else {
    const params = {
      stockCode: item.code.split('!')[j],
    };
    jumpTimeShare(params);
  }
}

/**
 * 获取关注信息并且注册成响应式
 */
export function getFollowInfo() {
  // 三个关注
  const handleObj = [
    // 行业
    {
      api: getFollowIndustry,
      id: 'industryId',
      list: '$followIndustryList',
    },
    // 机构
    {
      api: getFollowOrg,
      id: 'orgId',
      list: '$followOrgList',
    },
    // 分析师
    {
      api: getFollowAuthor,
      id: 'authorId',
      list: '$followAuthorList',
    },
  ];
  handleObj.forEach(handle => {
    handle.api({}).then(res => {
      if (res.statusCode === 0 && res.data.followList) {
        // 格式化数据
        const arr = res.data.followList.map(item => item[handle.id]);
        arr.forEach(element => {
          // 数据存储进去
          Vue.set(Vue.prototype[handle.list], element, true);
        });
        for (const key in Vue.prototype[handle.list]) {
          // 遍历对象数据 如果对象里面有但是后端没有的话要置为false
          if (Object.prototype.hasOwnProperty.call(Vue.prototype[handle.list], key)) {
            // 将对象数据处理为对应的状态
            Vue.set(Vue.prototype[handle.list], key, arr.includes(key));
          }
        }
      }
    });
  });
}

/**
 * 格式化港股代码
 * @param code 股票代码
 * @param marketId 市场ID
 * @returns 格式化后的股票代码
 */
export function formateHkStockcode(code: string, marketId: string | null): string {
  let stockcode = code;
  if (!stockcode) {
    return '';
  }
  if (!stockcode.includes('!')) {
    // 格式化hk
    const hk = `HK${stockcode.substr(1)}`;
    if ((marketId === '177' || marketId === '178') && stockcode.indexOf('0') === 0) {
      // 有市场id
      stockcode = hk;
    } else {
      if (!marketId && stockcode.indexOf('0') === 0 && stockcode.length === 5) {
        // 没市场id 股票代码长度为5 首位为0
        stockcode = hk;
      }
    }
    Vue.prototype.$hqData.addStockSub(stockcode, marketId);
  }
  return stockcode;
}

/**
 * 获取元素到页面顶部的距离
 * @param element 需要获取信息的dom
 * @returns number 距离
 */
export function getDomTop(element: HTMLElement): number {
  //获取元素距离页面顶部的距离
  let realTop = element.offsetTop;
  let parent = element.offsetParent as HTMLElement;
  while (parent !== null) {
    realTop += parent.offsetTop;
    parent = parent.offsetParent as HTMLElement;
  }
  return realTop;
}

/**
 * 设置页面标题，端内需要调用对应协议才能生效
 * @param title 需要设置的标题
 */
export function updateTitle(title: string) {
  document.title = title;
  if (/hexin/gi.test(navigator.userAgent)) {
    if (navigator.userAgent.toLowerCase().indexOf('android') >= 0) {
      window.callNativeHandler('changeWebViewTitle', {
        title,
        url: '',
      });
    } else {
      window.callNativeHandler('updateTitleAutomatically');
    }
  }
}
